import BasicVariablesView from "./basic_variablesview"


const BasicDebugView = () => {

  return <div className="flex-row">
    <BasicVariablesView/>
  </div>

}

export default BasicDebugView
